import { jsx as _jsx } from "react/jsx-runtime";
import { SSITabViewHeaderContainerStyled as Container, SSITabViewHeaderTitleContainerStyled as TitleContainer, SSITabViewHeaderTitleCaptionStyled as TitleCaption, } from '../../../../styles';
const SSITabViewHeader = (props) => {
    const { navigationState, onIndexChange } = props;
    return (_jsx(Container, { children: navigationState.routes.map((value, index) => {
            const tabIndex = index + 1;
            const isActiveTab = tabIndex === navigationState.index;
            return (_jsx(TitleContainer, { onClick: () => onIndexChange(tabIndex), style: {
                    ...(isActiveTab && { borderBottom: `2px solid #7276F7`, alignSelf: 'stretch' }),
                }, children: _jsx(TitleCaption, { style: { fontWeight: !isActiveTab ? '400' : '600' }, children: value.title }) }, tabIndex));
        }) }));
};
export default SSITabViewHeader;
